// extracted by mini-css-extract-plugin
module.exports = {"CourseDetail":"CourseDetail_CourseDetail__1wmC2","CourseDetail__Detail":"CourseDetail_CourseDetail__Detail__rEhuV","CourseDetail__Time":"CourseDetail_CourseDetail__Time__xe8pI"};